import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IdleService } from './Services/idle-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent implements OnInit {
  
  ngOnInit(){   
    this.idleService.init();
    /*if(localStorage.getItem("token")!=undefined){ 
      if(localStorage.getItem("type")=="admin"){
        this.router.navigate(['/profile']);
      }else if(localStorage.getItem("type")=="company" ||localStorage.getItem("type")=="person" ){
        if(localStorage.getItem("page")=="region"){
          this.router.navigate(['/escoge-tu-region']);
        }else{
          this.router.navigate(['/profile/pedido']);
        }        
      }else if(localStorage.getItem("type")=="motorizado"){
        this.router.navigate(['/motorizado']);
      }      
      return false;
    }else{
      this.router.navigate(['/login']);
      return false;
    }   */

    if(window.location.pathname=="/" && localStorage.getItem("token")!=undefined){
      if(localStorage.getItem("type")=="administrador"){
        this.router.navigate(['/profile/map-admin']);
      }else{
        this.router.navigate(['/profile/pedido']);
      }
      
    }
  }
 
  constructor(
    private router :Router ,
    private idleService: IdleService 
  ){ }
}
